import axios from "axios";
import { _axios } from "../../../../utils/axios";
import { useEffect, useState } from "react";
import { BASE_URL } from "../../../../constants/Constants";
import { ErrorToast } from "../../../toastMessage";

const Footer = () => {
  const [footerText, setFooterText] = useState("");

  useEffect(() => {
    // Fetch data from the backend when the component mounts
    fetchData();
  }, []);

  const fetchData = () => {
    _axios
      .post(`${BASE_URL}/api/footer/footer`)
      .then((response) => {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message);
          return;
        }
        const data = response.data.data[0];
        setFooterText(data.footer_text || "");
        console.log(response);
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          ErrorToast(error?.response?.data?.message);
        }
        console.log("error", error);
      });
  };

  return (
    <footer className="shrink-0 text-center p-4 bg-white border-t-2 box-border border-gray-200">
      <p className="text-grey-600">
        {footerText ||
          "Powered by Stralto Global Pvt. Ltd All Rights Reserved."}
      </p>
    </footer>
  );
};

export default Footer;
